(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/game-card/extra-game-info.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/game-card/extra-game-info.js');

'use strict';

const {
  isLotto
} = svs.numbergames.productMapping;
const ExtraGameInfo = _ref => {
  let {
    hasJoker,
    hasLotto2,
    productId,
    price
  } = _ref;
  const texts = [];
  if (isLotto(productId)) texts.push('Lotto 1');
  if (hasLotto2) texts.push('& 2');
  if (hasJoker) texts.push('+ Joker');
  if (price) texts.push("".concat(price, " kr"));
  const infoString = texts.join(' ');
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "card-extra-info"
  }, infoString));
};
svs.gamePackage.components.ExtraGameInfo = ExtraGameInfo;

 })(window);